import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useUserByteBreakdown = ({ userId }) => {
  const [breakdown, setBreakdown] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isMounted = true

    if (!userId) {
      setBreakdown(null)
      setLoading(false)
      setError(null)
      return
    }

    async function fetchBreakdown() {
      if (isMounted) { setLoading(true); setError(null) }

      try {
        const { data, error: err } = await supabaseGetter.metering.getUserByteBreakdown(userId)
        if (err) throw err
        if (!isMounted) return
        setBreakdown(data)
      } catch (err) {
        if (!isMounted) return
        console.error('[useUserByteBreakdown]', err)
        setError(err.message || 'Failed to fetch storage breakdown')
        setBreakdown(null)
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchBreakdown()
    return () => { isMounted = false }
  }, [userId])

  const total = breakdown
    ? Object.values(breakdown).reduce((sum, v) => sum + (v || 0), 0)
    : null

  return { breakdown, total, loading, error }
}
